<template>
    <div class="tickets-filter__filter-values">
        <div class="tickets-filter__checkbox-wrapper" v-for="value in filterValues" :key="value">
            <input
                type="checkbox"
                :id="`filter${value}`"
                :value="value"
                @change="toggleFilter(value)"
                class="tickets-filter__checkbox"
            />
            <label :for="`filter${value}`" class="tickets-filter__label">
                <DsChip
                    tag="span"
                    type="filter"
                    :is-active="checkedFilters.includes(value)"
                    class="tickets-filter__chip"
                >
                    {{ value }}&nbsp;Kč
                </DsChip>
            </label>
        </div>
    </div>
</template>

<script setup lang="ts">
import DsChip from "@sazka/design-system/src/chip/ds-chip.vue";
import { checkedFilters, useTicketsFilterHelper } from "@/tickets/components/tickets-filter/tickets-filter-state";

defineProps<{
    filterValues: Set<number>;
}>();

const { addFilter, removeFilter } = useTicketsFilterHelper();

const toggleFilter = (value: number) => {
    if (checkedFilters.value.includes(value)) {
        removeFilter(value);
    } else {
        addFilter(value);
    }
};
</script>
